/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Share_RevokedInputs */

const en_error_crm_share_revoked = /** @type {(inputs: Error_Crm_Share_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This share was revoked: share the report again to send a new link.`)
};

/**
* | output |
* | --- |
* | "This share was revoked: share the report again to send a new link." |
*
* @param {Error_Crm_Share_RevokedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_share_revoked = /** @type {((inputs?: Error_Crm_Share_RevokedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Share_RevokedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_share_revoked(inputs)
});